// import React from 'react';
// import { Redirect, useLocation } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import FuseUtils from '@fuse/utils';
// import LoginConfig from 'app/admin/login/LoginConfig';
// import LogoutConfig from 'app/admin/logout/LogoutConfig';
// import PasswordConfig from 'app/admin/password/PasswordConfig';
// import AdminConfig from 'app/admin/AdminConfig';

// const routeConfigs = [LoginConfig, LogoutConfig, PasswordConfig, AdminConfig];

// function RootRedirect() {
//   const { pathname } = useLocation();
//   const roles = useSelector(({ auth }) => auth.user?.data?.roles);

//   if (!Array.isArray(roles)) return null;

//   const hasReviewerRole = roles.some(r => String(r).toLowerCase() === 'reviewer');
//   const target = hasReviewerRole ? '/kerdes' : '/user';

//   if (pathname === target) return null;
//   return <Redirect to={target} />;
// }

// const routes = [
//   ...FuseUtils.generateRoutesFromConfigs(routeConfigs),
//   { path: '/', exact: true, component: RootRedirect }
// ];

// export default routes;


import { Redirect } from 'react-router-dom';
import FuseUtils from '@fuse/utils';
import LoginConfig from 'app/admin/login/LoginConfig';
import LogoutConfig from 'app/admin/logout/LogoutConfig';
import PasswordConfig from 'app/admin/password/PasswordConfig';
import AdminConfig from 'app/admin/AdminConfig';

const routeConfigs = [LoginConfig, LogoutConfig, PasswordConfig, AdminConfig];

const routes = [
  // if you want to make whole app auth protected by default change defaultAuth for example:
  // ...FuseUtils.generateRoutesFromConfigs(routeConfigs, ['admin','staff','user']),
  // The individual route configs which has auth option won't be overridden.
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs),
  {
    path: '/',
    // component: () => <Redirect to="/profile" />
    component: () => <Redirect to="/kerdes" />
  }
];

export default routes;